export const chipTestIds = {
  outerTag: "chip-tag",
  closeIcon: "close-icon",
};
